<template>
    <div>
        <template>
          <h4 class="not-margin" :style="{marginTop: '10px'}">
              <img src="../../../assets/cancel.png" class="img-delete">
          </h4>
        </template>

        <div class="con-content" :style="{ marginTop: '5px' }">
            <p :style="{fontSize: '18px', color: '#195BFF'}">
                {{ $t("exchangeItem.cancel_confirm_text") }}
            </p>
        </div>

        <template>
          <div class="con-footer" :style="{ marginTop: '25px' }">
            <vs-button :loading="loading" transparent :style="{color: 'crimson'}" @click="cancelExchange(exchangeId)">
              {{ $t("exchangeItem.confirm") }}
            </vs-button>
            <vs-button  @click="$emit('close')" dark transparent>
              {{ $t("exchangeItem.cancel") }}
            </vs-button>
          </div>
        </template>
    </div>
</template>
<script>

export default {
    props:['exchangeId'],

    data:()=>({
     loading: false
    }),
     methods:{
       cancelExchange(exchangeId){
          this.loading = true;
          this.$http.post('cancel/exchange/item/' + exchangeId).then(res=>{
              if(res.data.success === true){
                  setTimeout(() => {
                    this.loading = false;
                    this.$emit('close');
                    this.$emit('success');
                    this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'danger', 3000);
                  }, 300);
              }
          }).catch(()=>{});
        }
    }
}
</script>
<style lang="scss">

</style>
